// The community's own social profiles. Single source for the header icons, the registration
// page and the SEO `sameAs` list.
//
// public/index.html repeats these in its static JSON-LD and <noscript> block (it cannot import
// JS). src/seo/indexHtml.test.js fails if the two drift apart.
//
// Order matters: Discord first — it is where the community actually lives.
export const SOCIAL_LINKS = {
  discord: "https://discord.com/invite/slickracingua",
  youtube: "https://www.youtube.com/@slickracingukraine",
  instagram: "https://www.instagram.com/slickracing.ukraine/",
  tiktok: "https://www.tiktok.com/@slickracingua",
};
